import { LOG_API_URL } from "../../config";

/**
 * The only supported log sink is the Django log server (see
 * server/django-log-server in its own deployment — it does not live in or
 * get started from this repo). REACT_APP_LOG_API_URL must be set to its
 * full URL per environment; if it's unset, there is nowhere to send logs
 * and the caller should treat logging as effectively off.
 */
export const getLogEndpoint = (): string => LOG_API_URL || "";
